import React from 'react'
import Navbar from '../inc/Navbar'
import Slider from '../inc/Slider'
import kingroom from "../images/room.jpeg";
import deluxeroom from "../images/Deluxe room_vihan.jpg";
import Superdeluxe from "../images/Vinodini.JPG";
import familyroom from "../images/Family Room.JPG";
import cottageroom from "../images/deluxe.jpeg";
import standard from "../images/standard.jpg";
import cafe from "../images/cafe_vilas club resort.jpg";
import vintagecafe from "../images/cafe.jpg";
import multicuisine from "../images/Multicuisine Restaurants.jpg";
import restaurant_berhampore from "../images/MULTICUISINE RESTAURANT.jpg";
import ScrollToTop from "react-scroll-to-top";
import "./Home.css";
import Gallery from './Gallery';
import Corporate from './Corporate';
import Newgallery from './Newgallery';

function Home() {
  return (
    <div>
      <Navbar />
      <br />
      <br />
      <br />
      <br />
      <Slider />
      <br />
      <ScrollToTop smooth top="100" color="maroon" />
      <div style={{ color: "Green", display: 'flex', justifyContent: 'flex-start', margin: "2px" }} className="fixed-bottom shadow mb-1">

        <a className='vevaroom shadow' href='tel: 9046258702'><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" style={{ color: "maroon" }} fill="currentColor" class="bi bi-telephone" viewBox="0 0 16 16">
          <path d="M3.654 1.328a.678.678 0 0 0-1.015-.063L1.605 2.3c-.483.484-.661 1.169-.45 1.77a17.6 17.6 0 0 0 4.168 6.608 17.6 17.6 0 0 0 6.608 4.168c.601.211 1.286.033 1.77-.45l1.034-1.034a.678.678 0 0 0-.063-1.015l-2.307-1.794a.68.68 0 0 0-.58-.122l-2.19.547a1.75 1.75 0 0 1-1.657-.459L5.482 8.062a1.75 1.75 0 0 1-.46-1.657l.548-2.19a.68.68 0 0 0-.122-.58zM1.884.511a1.745 1.745 0 0 1 2.612.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.68.68 0 0 0 .178.643l2.457 2.457a.68.68 0 0 0 .644.178l2.189-.547a1.75 1.75 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.6 18.6 0 0 1-7.01-4.42 18.6 18.6 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877z" />
        </svg> <b>Call with Us</b></a>
      </div>
      <div className="album py-0">
        <div className="container">
          <div className='colorstay'>
            <h1 className='mt-3'>Stay at <b>Vila's Club Resort</b></h1>
          </div>
        </div>
      </div>
      <div className='album py-0'>
        <div className='container'>
          <div className="row">
            <div className="col-md-4 mt-3">
              <div className='homecard'>
                <a href='king-room'>
                  <div className="card" >

                    <img src={kingroom} className="card-img-top" alt="kingroom" />

                    <div className="card-body">
                      <h5 className="card-title">King Room</h5>
                      <p className="card-text">ROOM NO. - VEENU 03, VANI 004, VEENA 005. VELA 006</p>
                      <a href="king-room" className="button"><span>LEARN MORE</span></a>
                    </div>
                  </div>
                </a>
              </div>
            </div>
            <div className="col-md-4 mt-3">
              <div className='homecard'>
                <div className="card" >
                  <img src={standard} className="card-img-top" alt="standard" />
                  <div className="card-body">
                    <h5 className="card-title">Standard Room</h5>
                    <p className="card-text">ROOM NO. - VENILA 107, VENISHA 108</p>
                    <a href="#" className="button"><span>LEARN MORE</span></a>
                  </div>
                </div>
              </div>
            </div>


            <div className="col-md-4 mt-3">
              <div className='homecard'>
                <a href='cottage-room'>
                  <div className="card" >
                    <img src={cottageroom} className="card-img-top" alt="cottageroom" />
                    <div className="card-body">
                      <h5 className="card-title">Cottage Room</h5>
                      <p className="card-text">ROOM NO. - VENUS 001, VENISHA 002</p>
                      <a href="cottage-room" className="button mt-3"><span>LEARN MORE</span></a>
                      <br />
                    </div>
                  </div>
                </a>
              </div>
            </div>
            <div className="col-md-4 mt-3">
              <div className='homecard'>
                <a href='deluxe-room'>
                  <div className="card" >
                    <img src={deluxeroom} className="card-img-top" alt="deluxeroom" />
                    <div className="card-body">
                      <h5 className="card-title">Deluxe Room</h5>
                      <p className="card-text">ROOM NO. - VEVA 101, VERA 102, VIHAN 103, VIVEN 104, VILASHINI 105, VIRAJINI 205</p>
                      <a href="deluxe-room" className="button mt-3"><span>LEARN MORE</span></a>
                      <br />
                    </div>
                  </div>
                </a>
              </div>
            </div>


            <div className="col-md-4 mt-3">
              <div className='homecard'>
                <a href='Super-deluxe-room'>
                  <div className="card" >
                    <img src={Superdeluxe} className="card-img-top" alt="Superdeluxe" />
                    <div className="card-body">
                      <h5 className="card-title">Super Deluxe Room</h5>
                      <p className="card-text">ROOM NO. - VEVA 101, VERA 102, VIHAN 103, VIVEN 104, VILASHINI 105, VIRAJINI 205</p>
                      <a href="Super-deluxe-room" className="button mt-3"><span>LEARN MORE</span></a>
                      <br />
                    </div>
                  </div>
                </a>
              </div>
            </div>

            <div className="col-md-4 mt-3">
              <div className='homecard'>
                <a href='family-room'>
                  <div className="card" >
                    <img src={familyroom} className="card-img-top" alt="familyroom" />
                    <div className="card-body">
                      <h5 className="card-title">Family Room</h5>
                      <p className="card-text">ROOM NO. - VEVA 101, VERA 102, VIHAN 103, VIVEN 104, VILASHINI 105, VIRAJINI 205</p>
                      <a href="family-room" className="button mt-3"><span>LEARN MORE</span></a>
                      <br />
                    </div>
                  </div>
                </a>
              </div>
            </div>

            <div className="col-md-4 mt-3">
              <div className='homecard'>
                <a href='#'>
                  <div className="card" >
                    <img src={deluxeroom} className="card-img-top" alt="deluxeroom" />
                    <div className="card-body">
                      <h5 className="card-title">Suite Room</h5>
                      <p className="card-text">ROOM NO. - VELENTINE 301</p>
                      <a href="#" className="button mt-3"><span>LEARN MORE</span></a>
                      <br />
                    </div>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <br />
      <br />
      <div className="album py-0">
        <div className="container">
          <div className='colorstay'>
            <h1 className='mt-3'>FAMOUS <b>VINTAGE CAFE</b> at Berhampore</h1>
          </div>
        </div>
      </div>
      <div className='album py-0'>
        <div className='container'>
          <div className="row">
            <div className="col-md-6 mt-2">
              <div className='imgradius'>
                <img src={cafe} className="card-img-top" alt="best cafe murshidabad" />
              </div>
            </div>
            <div className="col-md-6 mt-2">
              <div className='imgradius'>
                <img src={vintagecafe} className="card-img-top" alt="vintagecafe_berhampore" />
              </div>
            </div>
          </div>
          <div className="d-flex justify-content-end align-items-end mb-0">
            <a href='Vintagecafe'>
              <button className='morephoto mt-3'>More Photo & Menu <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right" viewBox="0 0 16 16">
                <path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8" />
              </svg></button>
            </a>
          </div>
        </div>
      </div>
      <br />

      <div className="album py-0">
        <div className="container">
          <div className='colorstay'>
            <h1 className='mt-3'>FAMOUS <b>MULTICUISINE RESTAURANT</b> at Berhampore</h1>
          </div>
        </div>
      </div>
      <div className='album py-0'>
        <div className='container'>
          <div className="row">
            <div className="col-md-6 mt-2">
              <div className='imgradius'>
                <img src={restaurant_berhampore} className="card-img-top" alt="restaurant_berhampore murshidabad" />
              </div>
            </div>
            <div className="col-md-6 mt-2">
              <div className='imgradius'>
                <img src={multicuisine} className="card-img-top" alt="multicuisine restaurant_berhampore" />
              </div>
            </div>
          </div>
          <div className="d-flex justify-content-end align-items-end mb-0">
            <a href='multicuisine-menu'>
              <button className='morephoto mt-3'>More Photo & Menu <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right" viewBox="0 0 16 16">
                <path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8" />
              </svg></button>
            </a>
          </div>
        </div>
      </div>
      <br />

      <div className="containerse">

        <br />
        <br />
        <br />
        <br />

        <div className='contact'>
          <h1 ><b>Vila's Club Resort</b></h1><br />
          <br />
          <br />

        </div>
      </div>
      <br />
      <div className='album py-0'>
        <div className='container'>
          <div className='gallery'>
            <h1><b>VILA'S CLUB RESORT Gallery</b></h1>
          </div>
        </div>
      </div>
      <Gallery />
      {/* <Newgallery/> */}
      <br />
      <br />
      <Corporate />
      <br />

    </div>
  )
}

export default Home